import React from "react";

export const ShimmerEffect: React.FC = () => (
  <div className="h-full w-full animate-pulse rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200" />
);
